<button
	[ngClass]="classNames"
	[type]="htmlType"
	[disabled]="disabled"
	(click)="propagateEvent()"
>
	<span [ngClass]="'btn__icon-bg' | prefix: prefix"></span>
	<span [ngClass]="'btn__copy' | prefix: prefix">
		<app-fm-button-icon [prefix]="prefix" [icon]="icon"></app-fm-button-icon>
		<span [ngClass]="'btn__label' | prefix: prefix">{{ text }}</span>
	</span>
	<app-fm-button-loading
		*ngIf="loading"
		[prefix]="prefix"
	></app-fm-button-loading>
</button>
